import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-8 flex my-3 justify-center" }
const _hoisted_2 = { class: "flex items-center justify-center m-0 text-gray-600 text-xs sm:text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: "exchangeStatus",
      class: _normalizeClass(["w-16 text-white text-sm flex justify-center items-center rounded mr-1", {
        'bg-primary-light': _ctx.isAdding,
        'bg-gray-500': !_ctx.isAdding,
      }])
    }, _toDisplayString(_ctx.resultLabel), 3),
    _createElementVNode("label", {
      for: "exchangeStatus",
      class: _normalizeClass(["w-16 text-xs flex justify-center items-center rounded mr-1", {
        'text-primary-light': _ctx.isAdding,
        'text-gray-500': !_ctx.isAdding,
      }])
    }, _toDisplayString(_ctx.transactedPoint), 3),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.loggedAt), 1)
  ]))
}